import { CarouselContext, CarouselProvider } from "pure-react-carousel";
import React, { useContext, useEffect, useState } from "react";

import { useElementSize } from "../../Hooks/LayoutHooks";
import "./Dots.scss";

const dotWrapperWidth = 16;
interface Props {
  numberOfDots?: number;
  activeDot?: number;
  dotClicked?: (index: number) => void;
}

function middleNumber(n) {
  return Math.floor(n / 2);
}

interface DotProps {
  index: number;
  activeIndex: number;
  onClick: () => void;

  followingSizeArray: number[];
  previousSizeArray: number[];
}

function stepsByIntegerBettweenTwoNumbers(start, end, steps) {
  if (steps < 1) {
    steps = 1;
  }

  const step = (end - start) / (steps - 1);
  return Array(steps)
    .fill(0)
    .map((_, i) => start + step * i);
}

function Dot(props: DotProps) {
  const { index, activeIndex, followingSizeArray, previousSizeArray } = props;

  let scale = 0;
  let alpha = 0;
  if (index == activeIndex) {
    scale = 1;
    alpha = 1;
  }

  if (index > activeIndex) {
    const indexInSizeArray = index - activeIndex - 1;
    if (indexInSizeArray < followingSizeArray.length) {
      alpha = (followingSizeArray[indexInSizeArray] / 100) * 0.8;
      scale = followingSizeArray[indexInSizeArray] / 100;
    }
  }
  if (index < activeIndex) {
    const indexInSizeArray = activeIndex - index - 1;
    if (indexInSizeArray < previousSizeArray.length) {
      alpha = (followingSizeArray[indexInSizeArray] / 100) * 0.8;
      scale = followingSizeArray[indexInSizeArray] / 100;
    }
  }

  return (
    <div
      className="scc-dotWrapper"
      style={{
        left: index * dotWrapperWidth + "px"
      }}
    >
      <span
        style={{
          transform: `scale(${scale})`,
          opacity: alpha
        }}
        className={index == activeIndex ? "scc-dot scc-activeDot swivl-primaryButton" : "scc-dot swivl-primaryButton"}
        onClick={props.onClick}
      />
    </div>
  );
}

export function Dots(props: Props) {
  const carouselContext = useContext(CarouselContext);
  const [currentSlide, setCurrentSlide] = useState(carouselContext.state.currentSlide);
  const [totalSlides, setTotalSlides] = useState(carouselContext.state.totalSlides);

  useEffect(() => {
    function onChange() {
      setCurrentSlide(carouselContext.state.currentSlide);
      setTotalSlides(carouselContext.state.totalSlides);
    }
    carouselContext.subscribe(onChange);
    return () => carouselContext.unsubscribe(onChange);
  }, [carouselContext]);

  let numberOfDots;
  let activeDot;

  if (carouselContext) {
    numberOfDots = totalSlides;
    activeDot = currentSlide;
  } else {
    numberOfDots = props.numberOfDots;
    activeDot = props.activeDot;
  }

  const { dotClicked } = props;
  const [squareRef, { width, height }] = useElementSize();

  const _width = width ? width : 150; // width;
  const maxToShow = Math.max(3, Math.ceil(_width / dotWrapperWidth));

  const middle = _width / 2;
  const activeDotPosition = activeDot * dotWrapperWidth;
  let offset = 0;
  let pastMiddle = false;

  let slots = maxToShow; // How many dots can be on screen at once

  const middleSlot = middleNumber(slots); // the middle slot is the middle number of the slots

  if (activeDotPosition > middle) {
    pastMiddle = true;
    offset = activeDotPosition - middle + dotWrapperWidth / 2;
  }

  const numberToScaleDown = pastMiddle ? middleSlot - 1 : slots - activeDot; // the number of slots to scale down
  const followingSizeArray = stepsByIntegerBettweenTwoNumbers(100, 50, numberToScaleDown);
  const previousSizeArray = [...followingSizeArray].reverse();

  const dotsWrapperWidth = maxToShow > numberOfDots ? numberOfDots * dotWrapperWidth : maxToShow * dotWrapperWidth;

  return (
    <div ref={squareRef}>
      <div className="scc-dotsWrapper" style={{ width: dotsWrapperWidth + "px" }}>
        <div
          className="scc-dots"
          style={{
            width: numberOfDots * dotWrapperWidth + "px",
            transform: `translateX(-${offset}px)`
          }}
        >
          {Array(numberOfDots)
            .fill(0)
            .map((_, index) => {
              return (
                <Dot
                  key={index}
                  index={index}
                  activeIndex={activeDot}
                  onClick={() => {
                    if (dotClicked) {
                      dotClicked(index);
                    }
                    if (carouselContext) {
                      carouselContext.setStoreState({
                        currentSlide: index
                      });
                    }
                  }}
                  followingSizeArray={followingSizeArray}
                  previousSizeArray={previousSizeArray}
                />
              );
            })}
        </div>
      </div>
    </div>
  );
}
